import {
  Grid,
  FormControl,
  Typography,
  TextField,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  getData,
  storeData,
  getAllStorage,
  checkEditPage,
  callChoice,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import { isEmpty } from "lodash";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import DialogWait from "../../components/CustomDialog/DialogWait";
import { fomatterNumber, currencyFormat } from "../../utils/formatter";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";

const header = {
  headers: {
    "Content-Type": "application/json",
  },
};
var as = "";
var oc = {};

const InvestInfoAsset = (props) => {
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalErr, setIsModalErr] = useState(false);
  const [titleModalErr, setTitleModalErr] = useState("");
  const [msgModalErr, setMsgModalErr] = useState("");
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const [message_error, set_message_error] = useState("");
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  // Asset
  const [asset, setAsset] = useState("");
  // Outcome
  const [outcome, setOutcome] = useState({});
  // Text Error
  const [outcomeError, setOutcomeError] = useState("");
  const [textAssetError, setTextAssetError] = useState("");
  // Options data
  const [outcomes, setOutcomes] = useState([]);
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const f3Career = getData("f3_career");
  const f3Source = getData("f3_source_income");
  const f3Purpose = getData("f3_purpose_invest");
  const f3 = getData("f3_asset");
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  let snapIdCard = getData("uploadImage");

  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(f3Career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(f3Source) ||
      isEmpty(f3Purpose)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callGetOutcome = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/outcome`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setOutcomes(data);
            if (!isEmpty(f3.f3_outcome)) {
              data.forEach((ele) => {
                if (ele.Id === f3.f3_outcome) {
                  setOutcome(ele);
                  oc = ele;
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const openInfo = () => {
    setIsModal(true);
  };
  const onInitData = async () => {
    if (!isEmpty(f3)) {
      let dataOldAsset = "";
      if (!isEmpty(f3.f3_valuable)) {
        dataOldAsset = f3.f3_valuable;
      } else {
        dataOldAsset = "";
      }
      setAsset(dataOldAsset);
      as = dataOldAsset;
      checkEnable();
    }
  };
  const handleChangeAsset = (e) => {
    if (!isEmpty(e.target.value)) {
      setAsset(fomatterNumber(e.target.value));
    } else {
      setAsset("");
    }
    as = fomatterNumber(e.target.value);
    checkEnable();
  };
  const handleChangeOutcome = (e, value) => {
    if (!isEmpty(value)) {
      setOutcome(value);
    } else {
      setOutcome({});
    }
    oc = value;
    checkEnable();
  };
  const checkEnable = () => {
    if (isEmpty(as) || isEmpty(oc)) {
      setIsCheck(false);
    } else {
      setIsCheck(true);
    }
  };
  const setTextSummary = async (data) => {
    let text = {
      valuable: data.f3_valuable,
      outcome: outcome.ThName,
    };

    storeData("text_invest_asset", text);
    storeData("f3_asset", data);
    await postData(data);
  };
  const handleNext = async (e) => {
    e.preventDefault();
    let valid = await validate();
    if (valid) {
      let data = {
        head_token,
        f3_source: f3Source.f3_source,
        f3_source_text: f3Source.f3_source_text,
        f3_by_employee: f3Source.f3_by_employee,
        f3_by_heritage: f3Source.f3_by_heritage,
        f3_by_saving: f3Source.f3_by_saving,
        f3_by_invest: f3Source.f3_by_invest,
        f3_by_retired: f3Source.f3_by_retired,
        f3_by_private_business: f3Source.f3_by_private_business,
        f3_by_other: f3Source.f3_by_other,
        f3_by_other_text: f3Source.f3_by_other_text,

        f3_invest: f3Purpose.f3_invest,
        purpose_json: f3Purpose.purpose_json,

        f3_valuable: !isEmpty(asset) ? asset : "",
        f3_outcome: outcome.Id.toString(),

        f3_career: f3Career.f3_career,
        f3_career_text: f3Career.f3_career_text,
        f3_business: !isEmpty(f3Career.f3_business) ? f3Career.f3_business : "",
        f3_business_text: f3Career.f3_business_text,
        f3_income: f3Career.f3_income,
        f3_position: f3Career.f3_position,
        f3_officename: f3Career.f3_officename,
        f3_own: "1",
      };
      await setTextSummary(data);
    }
  };
  const validate = async () => {
    let valid = true;
    if (isEmpty(asset)) {
      valid = false;
      setTextAssetError("กรุณาระบุมูลค่าทรัพย์สินสุทธิ");
    }
    if (isEmpty(outcome)) {
      valid = false;
      setOutcomeError("กรุณาระบุภาระทางการงินต่อปี");
    }
    return valid;
  };
  const postData = async (data) => {
    // To do post data
    try {
      await GlobalApi.post(
        Configs.baseAPIURL03 + "/form/career_and_financial/manp",
        data,
        header,
      )
        .then((res) => {
          let result = res.data.Data[0][0];
          if (result) {
            if (editUrl) {
              storeData("editPage", "invest_asset");
              props.history.push("/summary");
            } else {
              postDataStatus();
            }
          }
        })
        .catch((error) => {
          if (!!error.isAxiosError && !error.response) {
            setTitleModalErr("เกิดข้อผิดพลาด");
            setMsgModalErr("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
            setIsModalErr(true);
          } else {
            let errorMessage = error.response
              ? error.response.data.message
              : "";
            setTitleModalErr("เกิดข้อผิดพลาด");
            setMsgModalErr(`axios or api error ${errorMessage}`);
            setIsModalErr(true);
          }
        });
    } catch (error) {
      setTitleModalErr("เกิดข้อผิดพลาด");
      setMsgModalErr("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
      setIsModalErr(true);
    }
  };
  const postDataStatus = async () => {
    setIsLoading(true);
    const family_status = getData("family_status");
    const data = {
      head_token,
      f1_marital_status: family_status.f1_marital_status,
      f1_spouse_title: family_status.f1_spouse_title,
      f1_spouse_is_th: family_status.f1_spouse_is_th,
      f1_spouse_firstname: family_status.f1_spouse_is_th
        ? family_status.f1_spouse_firstname
        : "",
      f1_spouse_lastname: family_status.f1_spouse_is_th
        ? family_status.f1_spouse_lastname
        : "",
      f1_spouse_title_text:
        family_status.f1_marital_status === "2" &&
        family_status.f1_spouse_title_text
          ? family_status.f1_spouse_title_text
          : "",
      f1_spouse_firstname_en: family_status.f1_spouse_firstname_en,
      f1_spouse_lastname_en: family_status.f1_spouse_lastname_en,
      f1_spouse_id_card: family_status.f1_spouse_id_card,
    };
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}/form/family_status/manp`,
        data,
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            postDataChildList();
          }
        })
        .catch((e) => {
          set_message_error(e);
          setIsModelWait(true);
          setIsLoading(false);
        });
    } catch (error) {
      set_message_error(error);
      setIsModelWait(true);
      setIsLoading(false);
    }
  };
  const postDataChildList = async () => {
    setIsLoading(true);
    const childList = getData("childList");
    let children_json = [];
    if (childList.radio !== "0") {
      childList?.data?.forEach((row) => {
        children_json.push({
          SAfc_THName: row?.firstName,
          SAfc_THSurname: row?.lastName,
          SAfc_CardID: row?.cardId,
          SAfc_Birthdate: row?.birthDate,
        });
      });
    }

    const data = {
      head_token,
      children_json,
    };
    try {
      GlobalApi.post(`${Configs.baseAPIURL03}/form/children/manp`, data, header)
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            if (editUrl) {
              storeData("editPage", "invest_asset");
              props.history.push("/summary");
            } else {
              saveComeback();
            }
          }
        })
        .catch((e) => {
          setModalErrorDes(e);
          setIsModalError(true);
          setIsLoading(false);
        });
    } catch (error) {
      setModalErrorDes(error);
      setIsModalError(true);
      setIsLoading(false);
    }
  };
  const saveComeback = async () => {
    storeData("stamp_page", "ATS");
    var last_stamp = JSON.stringify(await getAllStorage("ATS"));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "ATS",
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            props.history.push("/example_sign");
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
        callGetOutcome();
        onInitData();
      }
    });
  }, []);

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.asset?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) =>
              e ? props.history.push("/invest_info_purpose") : ""
            }
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btnPrimary={"ตกลง"}
          ></DialogError>
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.asset}
                        clickBack={(e) =>
                          props.history.push("/invest_info_purpose")
                        }
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.asset?.title}
                          />
                          <PanelScrollBar
                            size="full"
                            content={
                              <>
                                <Grid>
                                  <Grid className="pt-2 pb-2" container>
                                    <Grid className="font-20 text-primary font-DBHeavent font-weight-bold">
                                      {translations?.[lang]?.asset?.sub_title_1}
                                    </Grid>
                                    <Grid>
                                      <InfoIcon
                                        sx={{
                                          paddingLeft: "10px",
                                          paddingTop: "3px",
                                          color: "var(--lemon)",
                                          fontSize: "20px",
                                        }}
                                        onClick={openInfo}
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid className="input-form">
                                    <FormControl
                                      fullWidth
                                      variant="standard"
                                      error
                                    >
                                      <TextField
                                        fullWidth
                                        variant="standard"
                                        value={currencyFormat(asset)}
                                        placeholder="มูลค่าทรัพย์สินสุทธิ (บาท)"
                                        onChange={handleChangeAsset}
                                        type="tel"
                                      />
                                      <FormHelperText className="text-error">
                                        {textAssetError}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                                <Grid className="choices-box">
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20">
                                      {translations?.[lang]?.asset?.sub_title_2}
                                    </Typography>
                                  </Grid>
                                  <Grid className="input-form">
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <Autocomplete
                                        options={outcomes}
                                        value={outcome}
                                        getOptionLabel={(option) =>
                                          option.ThName ? option.ThName : ""
                                        }
                                        onChange={(e, value) =>
                                          handleChangeOutcome(e, value)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputProps={{
                                              ...params.InputProps,
                                              // readOnly: true,
                                            }}
                                            variant="standard"
                                            placeholder="กรุณาเลือก"
                                          />
                                        )}
                                      />
                                      <FormHelperText className="text-error">
                                        {outcomeError}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.asset?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* modal when click info asset */}
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            title={"มูลค่าทรัพย์สิน"}
            massage={
              "ทรัพย์สิน หมายถึง เงินฝาก เงินลงทุนโดยตรงในหลักทรัพย์หรือ สัญญาซื้อขายล่วงหน้า และสินทรัพย์สุทธิ (ไม่รวมอสังหาริมทรัพย์ที่เป็นที่อยู่อาศัย)"
            }
            btnPrimary={lang === "th" ? "กลับ" : "Back"}
          />
          <DialogCustoms
            open={isModalErr}
            isModel={setIsModalErr}
            title={titleModalErr}
            massage={msgModalErr}
            btnPrimary={"ตกลง"}
          />
        </>
      )}
    </>
  );
};
export default memo(InvestInfoAsset);
